import { gameStates } from "./gameStates";
import { globalData } from "./globalData";

export const demoData = {
    userInfo: {
        userName: "DEMO GAME",
        balance: 1000,
        isNewUser: false
    },
    betInfo: {
        betSettings: [1, 2, 5, 10, 50, 100, 200, 500, 1000],
        minBet: 1,
        maxBet: 1000,
        betMultiplier: 1
    },
    roundInfo: {
        roundSettings: [4, 5, 6, 7, 8, 9, 10, 11, 12],
    },
    sessionInfo: {
        totalRounds: 0,
        totalBet: 0,
        loseLimit: 0
    },
    currentRoundDetails: {
        roundNumber: 0,
        obstacleLane: null,
        roundWinnings: 0,
        gameResult: "pending",
        winType: null,
        multiplier: 1,
        numberOfWins: 0,
        numberOfLosses: 0,
    },
    winRate: {
        UpperSeed: 66,
        lowerSeed: 64.25,
        abateValue: 0.25
    }
}


const multipliers = {
    4: { 0: 0, 1: 0, 2: 0, 3: 0.5, 4: 10 },
    6: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0.5, 5: 3, 6: 20 },
    7: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0.5, 6: 5, 7: 50 },
    8: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0.5, 6: 2, 7: 5, 8: 75 },
    9: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0.5, 7: 3, 8: 15, 9: 100 },
    5: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0.5, 5: 20 },
    10: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0.5, 7: 1, 8: 5, 9: 20, 10: 150 },
    11: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0.5, 8: 2, 9: 5, 10: 25, 11: 500 },
    12: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0.5, 8: 1, 9: 2, 10: 5, 11: 25, 12: 1000 }
};

const winTypes = Object.freeze({
    NONE: "NONE",
    NORMAL_WIN: "NORMAL_WIN",
    BIG_WIN: "BIG_WIN",
    MEGA_WIN: "MEGA_WIN",
    ULTRA_WIN: "ULTRA_WIN",
});

let currentWinRate = demoData.winRate.UpperSeed;

export function placeBetSimulator(totalRounds, totalBet) {


    resetSimulator();

    demoData.sessionInfo.totalRounds = totalRounds;
    demoData.sessionInfo.totalBet = totalBet;
    demoData.userInfo.balance -= demoData.sessionInfo.totalBet
    globalData.currentGameState = gameStates.ROUND_START

    demoData.sessionInfo.loseLimit = getLoseLimit(totalRounds)

    return demoData.userInfo.balance;
}

function resetSimulator() {
    //reset round information
    demoData.currentRoundDetails.multiplier = 0
    demoData.currentRoundDetails.gameResult = "pending";
    demoData.currentRoundDetails.roundWinnings = 0;
    demoData.currentRoundDetails.winType = null;
    demoData.currentRoundDetails.numberOfLosses = 0;
    demoData.currentRoundDetails.numberOfWins = 0;
    demoData.currentRoundDetails.roundNumber = 0;
    demoData.currentRoundDetails.obstacleLane = null;

    //reset session information
    demoData.sessionInfo.totalBet = 0;
    demoData.sessionInfo.totalRounds = 0;
    demoData.sessionInfo.loseLimit = 0;

}


export function getObstacle(jeepneyLane, winRate) {
    // Simple secure random number between 0 and 1
    function secureRandom() {
        const array = new Uint32Array(1);
        window.crypto.getRandomValues(array);
        return array[0] / 0xFFFFFFFF;
    }

    const random = secureRandom(); // 0 to 1

    // If random < winRate%, it's a win → dodge obstacle
    const shouldWin = random < winRate / 100;

    // If shouldWin is true, place obstacle on opposite lane
    // If false, place obstacle on same lane (player hits)
    const obstacleLane = shouldWin
        ? (jeepneyLane === "L" ? "R" : "L")
        : jeepneyLane;

    return obstacleLane;
}



export function updateDemoRoundDetails(jeepneyLane) {
    demoData.currentRoundDetails.roundNumber++;

    demoData.currentRoundDetails.obstacleLane = getObstacle(jeepneyLane, currentWinRate);

    if (currentWinRate >= demoData.winRate.lowerSeed) currentWinRate -= demoData.winRate.abateValue;


    if (jeepneyLane == demoData.currentRoundDetails.obstacleLane) {
        demoData.currentRoundDetails.numberOfLosses++;
    } else {
        demoData.currentRoundDetails.numberOfWins++;
    }


    if (demoData.currentRoundDetails.roundNumber === demoData.sessionInfo.totalRounds
        || demoData.currentRoundDetails.numberOfLosses === demoData.sessionInfo.loseLimit - 1) {

        demoData.currentRoundDetails.multiplier = multipliers[demoData.sessionInfo.totalRounds][demoData.currentRoundDetails.numberOfWins];
        demoData.currentRoundDetails.roundWinnings = demoData.sessionInfo.totalBet * demoData.currentRoundDetails.multiplier;

        if (demoData.currentRoundDetails.roundWinnings) {
            if (demoData.currentRoundDetails.roundWinnings >= (demoData.sessionInfo.totalBet * 100)) {
                demoData.currentRoundDetails.winType = winTypes.ULTRA_WIN
            } else if (demoData.currentRoundDetails.roundWinnings >= (demoData.sessionInfo.totalBet * 20)) {
                demoData.currentRoundDetails.winType = winTypes.MEGA_WIN
            } else if (demoData.currentRoundDetails.roundWinnings >= (demoData.sessionInfo.totalBet * 5)) {
                demoData.currentRoundDetails.winType = winTypes.BIG_WIN
            } else {
                demoData.currentRoundDetails.winType = winTypes.NORMAL_WIN
            }

            demoData.userInfo.balance += demoData.currentRoundDetails.roundWinnings;
        }
        else {
            demoData.currentRoundDetails.roundWinnings = 0;
        }

        demoData.currentRoundDetails.gameResult = demoData.currentRoundDetails.multiplier ? "won" : "lost";
    } else {
        demoData.currentRoundDetails.multiplier = multipliers[demoData.sessionInfo.totalRounds][demoData.currentRoundDetails.numberOfWins];
        demoData.sessionInfo.gameResult = "pending";
        demoData.currentRoundDetails.roundWinnings = 0;
        demoData.currentRoundDetails.winType = null;
    }

}

function getLoseLimit(rounds) {
    if (!multipliers[rounds]) {
        // console.error("Invalid round number:", rounds);
        return -1;
    }

    const values = Object.values(multipliers[rounds]); // Convert object values to array
    const firstNonZeroIndex = values.findIndex(value => value > 0); // Find first non-zero

    return firstNonZeroIndex !== -1 ? firstNonZeroIndex : values.length; // Return count of leading zeros
}